/**
 * Permit API
 *
 * Outbound Works-Lite → CORE permit lifecycle calls. Each response is
 * whatever the backend returned; the button state UI is driven by the
 * subsequent inbound update that lands on job-detail via polling.
 *
 * Endpoints mounted at /works-lite/work-orders in the backend router.
 */

import { apiClient } from '@/lib/api';
import type {
  OutboundExtendPermitBody,
  OutboundRequestPermitBody,
  OutboundStartPermitBody,
  OutboundStopPermitBody,
} from '@skewb-works/contracts';

export interface PermitActionResult {
  jobId: number;
  permitId?: number;
  success: boolean;
  message: string;
}

export function requestPermit(body: OutboundRequestPermitBody): Promise<PermitActionResult> {
  return apiClient.post('/works-lite/work-orders/outbound/request-permit', body);
}

export function startPermit(body: OutboundStartPermitBody): Promise<PermitActionResult> {
  return apiClient.post('/works-lite/work-orders/outbound/start-permit', body);
}

export function stopPermit(body: OutboundStopPermitBody): Promise<PermitActionResult> {
  return apiClient.post('/works-lite/work-orders/outbound/stop-permit', body);
}

export function extendPermit(body: OutboundExtendPermitBody): Promise<PermitActionResult> {
  return apiClient.post('/works-lite/work-orders/outbound/extend-permit', body);
}
